import { FieldValues } from 'react-hook-form'
import { getAllFieldKeys, OnFilterType } from '../components/ListView/filterConfig'

// Re-export OnFilterType for convenience
export type { OnFilterType }


/**
 * Handle form submission and call onFilter with all field values
 * Uses FILTER_FIELDS config to determine which fields to extract
 *
 * NOTE: The fieldValues array is typed as any[] because TypeScript cannot verify
 * at compile time that the spread arguments match OnFilterType's parameters.
 * However, since both getAllFieldKeys() and OnFilterType are generated from
 * the same source (FILTER_FIELDS), we know they match at runtime.
 */
export const handleOnSubmit = (onFilter: OnFilterType) => {
  return (data: FieldValues) => {
    const fieldKeys = getAllFieldKeys()
    const fieldValues = fieldKeys.map((key) => data[key] || null)

    // Call onFilter with showSelected, selectedGuids, and all other fields in order
    // The spread is safe because fieldKeys order matches OnFilterType parameter order
    onFilter(
      data['showSelected'] || '',
      data['selectedGuids'] || null,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ...(fieldValues as any[]),
    )
  }
}
